import styled from "styled-components"

const Input = styled.input`
    height: 40px;
    padding: 3px 10px;
    border: 1px solid #eee;
    width: 100%;
`

export default Input;